import React from 'react';
import { Col, Row,Image } from 'antd';
import {useSelector} from "react-redux";
import '../index.css'


const ErrorCorrectionAnswer = (props) =>  {

    const {answer,sendTxt,setSendTxt} = props
    const data = answer?.content;
    const {size} = useSelector(state => state.fontSizeChange)
    const answerThree = {
        fontSize: size === '小' ? '14px' : (size === '中' ? '16px' : '18px'),
        paddingTop:'5px',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        lineHeight:'25px'
    }
    const answerTwo = {
        fontSize:size==='小'?'18px':(size==='中'?'21px':'25px')
    }
    const processListFormat = (v)=>{
        let str = "";
        v.map(res=>{
            if(res.includes('-')){
                str += "<span>"+res.replace('-','')+"</span>"
            }else if(res.includes('+')){
                str += "<font>"+res.replace('+','')+"</font>"
            }else{
                str += res
            }
        })
        return str
    }
    return (
        <div>
            <div>
                        {
                            answer?.responder_content[0].content.modified_text===answer?.responder_content[0].content.original_text?
                                <div>
                                    <div className='answerTwo' style={answerTwo}>
                                        <div>
                                            无需修改:
                                        </div>
                                        <div className='errorTab'>
                                            {answer?.responder_content[0].content.original_text}
                                        </div>
                                    </div>
                                </div>:
                                <div>
                                    <div className='answerTwo' style={answerTwo}>
                                        <div>
                                            纠错处理:
                                        </div>
                                        <div className='errorTab'>
                                            <div dangerouslySetInnerHTML={{__html:processListFormat(answer?.responder_content[0].content.process_list)}}></div>
                                        </div>
                                    </div>
                                    <div className='answerTwo' style={answerTwo}>
                                        <div>
                                            修改结果:
                                        </div>
                                        <div className='errorTab'>
                                            {answer?.responder_content[0].content.modified_text}
                                        </div>
                                    </div>
                                </div>
                        }
            </div>
        </div>
    );
}


export default ErrorCorrectionAnswer

